import { render, staticRenderFns } from "./runPosture.vue?vue&type=template&id=3902f0ab&scoped=true&"
import script from "./runPosture.vue?vue&type=script&lang=js&"
export * from "./runPosture.vue?vue&type=script&lang=js&"
import style0 from "./runPosture.vue?vue&type=style&index=0&id=3902f0ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3902f0ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3902f0ab')) {
      api.createRecord('3902f0ab', component.options)
    } else {
      api.reload('3902f0ab', component.options)
    }
    module.hot.accept("./runPosture.vue?vue&type=template&id=3902f0ab&scoped=true&", function () {
      api.rerender('3902f0ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/library/runPosture.vue"
export default component.exports